module.exports = __webpack_public_path__ + "media/unipod/pods-ceilings-ffd84083.png";